export enum WebsiteLanguage {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  IT = 'it',
}
